import React from 'react';
import classNames from 'classnames';
import styles from '../styles.scss';

interface IProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const CardFooter = ({ children, style, className }: IProps) => {
  const newStyles = {
    ...style,
  };

  return (
    <div className={classNames(styles.cardFooter, className)} style={newStyles}>
      {children}
    </div>
  );
};

export default CardFooter;
